import React from "react"

import CopyToClipboardButton from './copyToClipboardButton';
import { Badge, Link, Popover, SpaceBetween, StatusIndicator } from "@amzn/awsui-components-react";

export function renderElement(attributeName: string, attributeValue: React.ReactNode, copyText: string) {
    return (
        <div key={attributeName}>
            <div className="awsui-util-label">
                <strong>{attributeName}</strong>
                {copyText &&
                    <CopyToClipboardButton text={copyText}/>
                }
            </div>
            <div>
                <span>{attributeValue}</span>
            </div>
        </div>
    )
}

export function renderField(attributeName: string, attributeValue: string, additionalValue?: string) {
    return (
        <div key={attributeName}>
            <div className="awsui-util-label">
                <strong>{attributeName}</strong>
                <CopyToClipboardButton text={attributeValue}/>
            </div>
            <div>
                <span>{attributeValue}</span>
            </div>
            {additionalValue !== undefined &&
            <div>
                <span>{additionalValue}</span>
            </div>
            }
        </div>
    )
}

export function renderLink(attributeName: string, linkText: string, linkHref: string, textDescription: string = "") {
    return (
        <div key={attributeName}>
            <div className="awsui-util-label">
                <strong>{attributeName}</strong>
                <CopyToClipboardButton text={linkText} textDescription={textDescription} />
            </div>
            <div className="awsui-util-label">
                <Link target="_blank" href={linkHref}>{linkText}</Link>
            </div>
        </div>
    )
}

export function renderNetwork(attributeName: string, popoverText: string, attributeValue: string, additionalValue?: string) {
    return (
        <div key={attributeName}>
            <SpaceBetween size="xs">
                <div className="awsui-util-label">
                    <SpaceBetween direction="horizontal" size="xs" >
                        <strong>{attributeName}</strong>
                        <Popover
                            content={popoverText}
                            triggerType="text-inline"
                        >
                            <StatusIndicator type="info"></StatusIndicator>
                        </Popover>
                    </SpaceBetween>
                </div>
                <div>
                    <Badge color="blue">{attributeValue}</Badge>
                </div>
                {additionalValue !== undefined &&
                    <div>
                        <span>{additionalValue}</span>
                    </div>
                }
            </SpaceBetween>
        </div>
    );
}